/**
 * @remarks
 * This has changed over time, currently we only consider the status of 'ENABLED' to mean that
 * detection is active.
 * @param detectionStatus
 * @returns true if detection is enabled for the given status
 */
export const detectionIsOn = (
    detectionStatus: DetectionStatus | string | null | undefined,
): boolean => {
    if (detectionStatus === null || detectionStatus === undefined) {
        return false;
    }

    return detectionStatus === 'ENABLED';
};
